import React, {useState, useEffect} from 'react';
import Get from './components/Get';
import Header from './components/Header';
import Sidebar from './components/Sidebar';
import './home.css';
import betx from './images/betx.png';
import {MdArrowForward} from 'react-icons/md';
import {FaWhatsapp} from 'react-icons/fa';
import {useNavigate} from 'react-router-dom';
import BottomTabs from './BottomTabs';

const Home = () => {
  const [user, setUser] = useState(null);
  const [balance, setBalance] = useState(0);
  const [sidebar, setSidebar] = useState(false);
  const [games, setGames] = useState([]);
  const [activeTab, setActiveTab] = useState('home');
  const navigate = useNavigate();
  const [message, setMessage] = useState(null);
  const [showResultModal, setShowResultModal] = useState(false);
  const [helpNumber, setHelpNumber] = useState('');

  const [result, setResult] = useState({
    number: '25',
    game: {name: {name: 'Super Lotto'}},
  });

  useEffect(() => {
    Get.Setting().then(res => {
      if (res.data) {
        localStorage.setItem('setting', JSON.stringify(res.data));
        setMessage(res.data.banner);
        // Get help number if available
        if (res.data.help && res.data.help.text) {
          setHelpNumber(res.data.help.text);
        }
      }
    });
  }, []);

  useEffect(() => {
    // Retrieve user from localStorage
    const storedUser = localStorage.getItem('user');
    if (storedUser) {
      setUser(JSON.parse(storedUser));
    }
    fetchWallet();
    fetchGames();
  }, []);

  const fetchWallet = () => {
    Get.Wallet().then(res => {
      if (res.wallet && typeof res.wallet.balance !== 'undefined') {
        setBalance(res.wallet.balance);
      } else {
        setBalance(0); // fallback value
      }
    });
  };

  const fetchGames = () => {
    Get.Result().then(res => {
      setGames(res.games || []);
    });
  };

  const openWhatsApp = () => {
    const message = 'Hello, I need help';
    let whatsappUrl;

    if (helpNumber) {
      whatsappUrl = `https://wa.me/91${helpNumber}?text=${encodeURIComponent(
        message,
      )}`;
    } else {
      whatsappUrl = `https://wa.me/?text=${encodeURIComponent(message)}`;
    }

    window.open(whatsappUrl, '_blank');
  };

  useEffect(() => {
    const handleBackButton = event => {
      event.preventDefault();
      const confirmLogout = window.confirm(
        'Are you sure you want to logout and exit?',
      );
      if (confirmLogout) {
        localStorage.clear();
        navigate('/');
      } else {
        window.history.pushState(null, '', window.location.href);
      }
    };

    window.history.pushState(null, '', window.location.href);
    window.addEventListener('popstate', handleBackButton);

    return () => {
      window.removeEventListener('popstate', handleBackButton);
    };
  }, [navigate]);

  return (
    <>
      <div className="home-container">
        <Header
          showUser={true}
          sidebar={value => setSidebar(value)}
          balance={balance}
          showBackButton={false}
        />

        <div style={styles.profileCard}>
          <div style={styles.profileGradient}>
            <div style={styles.profileHeader}>
              <div style={styles.userInfo}>
                <div style={styles.userName}>{user?.name || 'User'}</div>
                <div style={styles.userPhone}>
                  +91 {user?.mobile || '0000000000'}
                </div>
              </div>

              <div style={styles.balanceContainer}>
                <div style={styles.balanceLabel}>Balance</div>
                <div style={styles.balanceAmount}>₹{balance || '0.00'}</div>
              </div>
            </div>

            <div style={styles.resultSection}>
              <div style={styles.logoContainer}>
                <img src={betx} alt="Logo" style={styles.logo} />
              </div>

              <div>
                {/* Button */}
                <button
                  onClick={() => setShowResultModal(true)}
                  className="resultButton">
                  <span className="resultButtonText">Latest Results</span>
                  <div className="resultArrow">
                    <MdArrowForward size={16} color="#fff" />
                  </div>
                </button>

                {/* Modal */}
                {showResultModal && (
                  <div className="modalOverlay">
                    <div className="modalContent">
                      <div className="modalGradient">
                        {/* Header */}
                        <div className="modalHeader">
                          <h2 className="modalTitle">Latest Results</h2>
                          <button
                            onClick={() => setShowResultModal(false)}
                            className="modalCloseButton">
                            ✕
                          </button>
                        </div>

                        {/* Result */}
                        <div className="modalResultContainer">
                          <h1 className="modalResultNumber pulse">
                            {result ? result.number : '--'}
                          </h1>
                          <p className="modalGameName">
                            {result ? result.game.name.name : ''}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
          {message && (
            <div style={styles.messageBanner}>
              <span style={styles.messageText}>
                Note: {message.text || message}
              </span>
            </div>
          )}
          <div className="results-section">
            <div className="section-title">Results</div>
            <div className="games-container">
              {games.map((data, index) => (
                <div key={index} className="game-card">
                  <div className="game-title">{data.name?.name || 'Game'}</div>
                  <div className="game-time">{data.result_time}</div>
                  <div className="latest-result">Latest</div>
                  <div className="latest-result2">
                    {data.result ? data.result.number : '--'}
                  </div>
                  <div className="previous-results">
                    {data.old_result &&
                      data.old_result.slice(1, 5).map((resultItem, idx) => (
                        <div key={idx} className="history-item">
                          <div className="history-number">
                            {resultItem.number}
                          </div>
                          <div className="history-date">
                            {new Date(resultItem.created_at).toLocaleDateString(
                              'en-GB',
                              {
                                day: '2-digit',
                                month: '2-digit',
                              },
                            )}
                          </div>
                        </div>
                      ))}
                  </div>
                </div>
              ))}
            </div>
          </div>

          <Sidebar
            visible={sidebar}
            balance={balance}
            onClose={() => setSidebar(false)}
          />
        </div>

        {/* Floating WhatsApp Button */}
        <button onClick={openWhatsApp} style={styles.whatsappFloat}>
          <FaWhatsapp size={32} color="#fff" />
        </button>
      </div>
      <BottomTabs />
    </>
  );
};

const styles = {
  messageBanner: {
    background: 'linear-gradient(90deg, #d13c3cff, #0c050588)',
    padding: '10px 15px',
    borderRadius: '6px',
    margin: '10px 0',
    textAlign: 'center',
  },
  messageText: {
    color: '#fff',
    fontSize: '14px',
    fontWeight: '500',
  },
  profileCard: {
    width: '100%',
    maxWidth: '400px',
    margin: '20px auto',
    borderRadius: '12px',
    overflow: 'hidden',
    boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
    fontFamily: 'Arial, sans-serif',
  },
  profileGradient: {
    background: 'linear-gradient(135deg, #1b4ca7ff, #0aa7788e)',
    color: '#fff',
    padding: '20px',
  },
  profileHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: '20px',
  },
  userInfo: {
    display: 'flex',
    flexDirection: 'column',
  },
  userName: {
    fontSize: '18px',
    fontWeight: 'bold',
  },
  userPhone: {
    fontSize: '14px',
    opacity: 0.8,
  },
  balanceContainer: {
    textAlign: 'right',
  },
  balanceLabel: {
    fontSize: '14px',
  },
  balanceAmount: {
    fontSize: '18px',
    fontWeight: 'bold',
  },
  resultSection: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  logoContainer: {
    flex: 1,
  },
  logo: {
    width: '80px',
    height: 'auto',
  },
  resultButton: {
    display: 'flex',
    alignItems: 'center',
    backgroundColor: '#ffffffff',
    border: 'none',
    borderRadius: '20px',
    padding: '10px 15px',
    cursor: 'pointer',
    color: '#000',
  },
  resultButtonText: {
    marginRight: '8px',
    fontWeight: 'bold',
  },
  resultArrow: {
    display: 'flex',
    alignItems: 'center',
    backgroundColor: '#c9c9c988',
    borderRadius: '50%',
    padding: '3px',
  },
  modal: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0,0,0,0.5)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  modalContent: {
    backgroundColor: '#fff',
    padding: '20px',
    borderRadius: '8px',
    textAlign: 'center',
  },
  whatsappFloat: {
    position: 'fixed',
    bottom: '70px',
    right: '25px',
    width: '60px',
    height: '60px',
    borderRadius: '50%',
    backgroundColor: '#25D366',
    border: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    boxShadow: '0 4px 12px rgba(37, 211, 102, 0.4)',
    zIndex: 1000,
    transition: 'transform 0.2s, box-shadow 0.2s',
  },
};

export default Home;
